import axios from "axios";
import { Dispatch } from "redux";
import {
  GET_DASHBOARD,
  GET_DASHBOARD_SUCCESS,
  GET_DASHBOARD_FAILURE,
  RESET_DASHBOARD,
  DashboardActionTypes,
} from "../types/dashboardType";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

export const getDashboard =
  () => async (dispatch: Dispatch<DashboardActionTypes>) => {
    try {
      dispatch({ type: GET_DASHBOARD, payload: [] });

      const response = await API.get("/dashboard-analytics", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: GET_DASHBOARD_SUCCESS, payload: response.data?.data });
      } else {
        dispatch({
          type: GET_DASHBOARD_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }

      dispatch({
        type: GET_DASHBOARD_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const resetDasboard =
  () => (dispatch: Dispatch<DashboardActionTypes>) => {
    dispatch({ type: RESET_DASHBOARD });
  };
